const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:8080';

export class MonitoringService {
    static async getDashboardData() {
        const response = await fetch(`${API_BASE_URL}/api/v3/monitoring/dashboard`);
        return response.json();
    }

    static async getThreadPoolStatus() {
        const response = await fetch(`${API_BASE_URL}/api/v3/monitoring/thread-pools`);
        return response.json();
    }

    static async getLiveStreamHealth() {
        const response = await fetch(`${API_BASE_URL}/api/v3/monitoring/live-stream-health`);
        return response.json();
    }

    static async getPerformanceMetrics() {
        const response = await fetch(`${API_BASE_URL}/api/v3/monitoring/translation-performance`);
        return response.json();
    }

    static async getAlerts() {
        const response = await fetch(`${API_BASE_URL}/api/v3/monitoring/alerts`);
        return response.json();
    }
}
